import { render, staticRenderFns } from "./member_xufei.vue?vue&type=template&id=1d08c071&scoped=true"
import script from "./member_xufei.vue?vue&type=script&lang=js"
export * from "./member_xufei.vue?vue&type=script&lang=js"
import style0 from "./member_xufei.vue?vue&type=style&index=0&id=1d08c071&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d08c071",
  null
  
)

export default component.exports